import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { useRouter } from "next/router";
import { Form, Input, message } from "antd";
import commonRules from "components/Pages/User/common/rules";
import SafeVerify from "components/App/SafeVerify";
import { axiosThrottle } from "utils/method";
import { waitRes } from "utils/axios";
import useNextTick from "hooks/useNextTick";

import { FaCheckProps } from "@/components/App/SafeVerify";
import { getUserInfo, get_getFaCheckItem, post_setAntiFishingCode, post_updateAntiFishingCode } from "@/api/uaapi/user";

const { useTranslation } = Hooks;
const { useForm } = Form;
interface AntiPhisingProps extends BaseCompProps {
  attr?: any;
}
interface antiFishingCodeDataProps {
  antiFishingCode: string;
  faCheckId: string;
}

const initForm: antiFishingCodeDataProps = {
  antiFishingCode: "",
  faCheckId: "",
};
//const { useTranslation } = Hooks;
const AntiPhising: React.FC<AntiPhisingProps> = ({ className }) => {
  const t = useTranslation();
  const router = useRouter();
  const nextTick = useNextTick();
  const { isDark } = store.app;
  const [formIns] = useForm();
  const [formData, setFormData] = useState({ ...initForm });
  const [faBizType, setFaBizType] = useState(21);
  const [antiFishingCode, setAntiFishingCodeChange] = useState("");
  const [faCheckData, setFaCheckData] = useState<FaCheckProps>({
    faCheckId: "",
    email: "",
    countryCode: "",
    mobile: "",
    faItems: [],
  });
  const [antiFishingCodeState, setAntiFishingCode] = useState(false);
  const getUserInfoData = async () => await getUserInfo();

  useEffect(() => {
    getFaCheckItem();
  }, []);
  /**method */
  const onValuesChange = (changedValues: Partial<antiFishingCodeDataProps>) => {
    setFormData({ ...formData, ...changedValues });
  };

  const getFaCheckItem = async () => {
    const info = await getUserInfoData();
    setAntiFishingCodeChange(info.antiFishingCode);
    let type = 21;
    if (info.antiFishingCode) {
      type = 22;
      setFaBizType(type);
    }
    const { data, err } = await waitRes(get_getFaCheckItem, {
      noHandle401: true,
      errorPop: true,
      params: { faBizType: type },
    });
    if (err) return;

    setFaCheckData(data);
    const newFormData = { ...formData };
    newFormData.faCheckId = data.faCheckId;

    newFormData.antiFishingCode = "";
    setFormData(newFormData);
  };

  const submitForm = axiosThrottle(async (unlock, res) => {
    try {
      await formIns.validateFields();
      const { err } = await waitRes(antiFishingCode ? post_updateAntiFishingCode : post_setAntiFishingCode, {
        errorPop: true,
        data: { ...formData, faResultId: res.faResultId },
      });
      unlock();
      if (err) return;
      if (!antiFishingCode)
        return message.success(t("2fa.setAntiFishingCode"), () => {
          router.push("/accounts/user/security-center");
        });
      message.success(t("2fa.updateAntiFishingCode"), () => {
        router.push("/accounts/user/security-center");
      });
    } catch (error) {}
  });

  useEffect(() => {
    if (!formData.antiFishingCode) {
      setAntiFishingCode(false);
      return;
    }
    const reg = /^[1-9a-z]\w{3,19}$/i;
    setAntiFishingCode(!reg.test(formData.antiFishingCode));
  }, [formData.antiFishingCode]);
  return (
    <div className={cx(styles.mobile, className, isDark ? styles["phising_dark"] : styles["phising_light"])}>
      {/* 顶栏由 pages/accounts/user 的 backHeader 统一提供，此处不再重复 */}
      <div className={styles["content"]}>
        <div className={styles["right_fa"]}>
          {/* 绑定/更改防钓鱼码 */}
          <div className={styles["right_1"]}>
            <div className={styles["title"]}>{antiFishingCode ? t("fish.change") : t("account.SetAntiPhishingCode")}</div>
            <div className={styles["prevent"]}>
              <div className={styles["fish"]}>
                <span className={styles["fish_title"]}>{t("account.AntiPhishingCode")}</span>
                <span className={styles["fish_text"]}>Spikex.567898</span>
              </div>
            </div>
            <div className={styles["tip"]}>
              <div className={styles["prevent_text"]}>{t("fish.setTip1")}</div>
              {antiFishingCode && (
                <>
                  <div className={styles["email_text"]}> {t("fish.old")}</div>
                  <div className={styles["antiFishingCode"]}>{`${antiFishingCode.substring(0, antiFishingCode.length - 2)}**`}</div>
                </>
              )}
            </div>
            <div className={styles["tip"]}>
              <Form name="fishForm" form={formIns} onValuesChange={onValuesChange} layout="vertical">
                <div className={styles["email_text"]}>{antiFishingCode ? t("fish.setNew") : t("fish.set")}</div>
                <Form.Item label={t("account.AntiPhishingCode")}>
                  <Form.Item noStyle name="antiFishingCode" rules={commonRules.antiFishingCode}>
                    <Input allowClear className={styles["common_form_input"]} autoComplete="new-text" />
                  </Form.Item>
                  <p className={cx(styles.ft_gray, antiFishingCodeState && styles["ft-red"])}>{t("fish.warning")}</p>
                </Form.Item>
              </Form>
              {/* 安全验证 */}
              {faCheckData.faItems.length > 0 && <div className={styles["email_text"]}>{t("app.2fa")}</div>}
              <SafeVerify
                faCheckData={faCheckData}
                showLink={true}
                faBizType={faBizType}
                dynamicCodeType={antiFishingCode ? "USER_2012" : "USER_2011"}
                handleSuccessFn={submitForm}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default observer(AntiPhising);
